import { Link } from "@tanstack/react-router";
import { MapPin, Phone, Mail } from "lucide-react";
import { useTranslation } from "react-i18next";
import logo from "@/assets/logo.webp";

export function SiteFooter() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-border/40 bg-card/50">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-3">
        <div>
          <Link to="/" className="flex items-center gap-3">
            <img src={logo} alt="Comm42" width={56} height={56} className="h-12 w-12 object-contain" />
          </Link>
          <p className="mt-4 max-w-sm font-serif text-lg italic text-muted-foreground">
            {t("footer.tagline")}
          </p>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.25em] text-primary">{t("footer.contactUs")}</h4>
          <ul className="mt-5 space-y-3 text-sm text-muted-foreground">
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
              <span className="whitespace-pre-line">{t("footer.address")}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-primary" /><span>+41 0918311215</span>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-primary" /><span>sales@comm42.eu</span>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.25em] text-primary">{t("footer.explore")}</h4>
          <ul className="mt-5 space-y-2 text-sm">
            <li><Link to="/strategic-consulting" className="text-muted-foreground hover:text-primary">{t("footer.nav.strategic")}</Link></li>
            <li><Link to="/logistics-transport" className="text-muted-foreground hover:text-primary">{t("footer.nav.logistics")}</Link></li>
            <li><Link to="/services" className="text-muted-foreground hover:text-primary">{t("footer.nav.services")}</Link></li>
            <li><Link to="/about" className="text-muted-foreground hover:text-primary">{t("footer.nav.about")}</Link></li>
            <li><Link to="/contact" className="text-muted-foreground hover:text-primary">{t("footer.nav.contact")}</Link></li>
          </ul>
          <h4 className="mt-8 text-xs tracking-[0.25em] text-primary">{t("footer.legal")}</h4>
          <ul className="mt-5 space-y-2 text-sm">
            <li><Link to="/privacy" className="text-muted-foreground hover:text-primary">{t("footer.privacy")}</Link></li>
            <li><Link to="/cookies" className="text-muted-foreground hover:text-primary">{t("footer.cookies")}</Link></li>
            <li><Link to="/impressum" className="text-muted-foreground hover:text-primary">{t("footer.impressum")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border/30">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-6 py-5 text-xs text-muted-foreground sm:flex-row">
          <p>© {new Date().getFullYear()} Comm42 SA. {t("footer.rights")}</p>
          <p className="tracking-widest">{t("footer.motto")}</p>
        </div>
      </div>
    </footer>
  );
}